import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Отправьте заявку и мы ответим в рабочее время',
  form: {
    phone: {
      placeholder: 'Введите ваш телефон',
      errors: {
        required: 'Необходимо заполнить',
      },
    },
    submitButton: 'Получить консультацию',
    closeButton: 'Закрыть',
    moreButton: 'Подробнее',
    comment: 'Заявка на консультацию с главной страницы',
  },
  agreement: {
    text: 'Даю {agreement} на обработку своих персональных данных в соответствии c {policy}',
    agreement: 'Согласие',
    policy: 'Политикой обработки персональных данных',
    required: 'Обязательное поле',
  },
} as const satisfies TMessages
